export const ContractsPicto = {
    ORANGE: {
        ACCUEIL: {
            ACTIVE: '/assets/images/contract/orange/orange_accueil2.png',
            INACTIVE: '/assets/images/contract/orange/orange_accueil.png',
        },
        SWITCH_CONTRACT: {
            ACTIVE: '/assets/images/contract/sosh/sosh_orange2.png',
            INACTIVE: '/assets/images/contract/sosh/sosh_orange.png',
        },
        ADD_CONTRACT: {
            ACTIVE: '/assets/images/contract/orange/orange_ajouter2.png',
            INACTIVE: '/assets/images/contract/orange/orange_ajouter.png',
        },
        PRO: {
            ACTIVE: '/assets/images/contract/orange/orange_orange2.png',
            INACTIVE: '/assets/images/contract/orange/orange_orange.png',
        },
        OBS: {
            ACTIVE: '/assets/images/contract/orange/orange_orange2.png',
            INACTIVE: '/assets/images/contract/orange/orange_orange.png',
        },
        BLOCKED: {
            ACTIVE: '/assets/images/contract/orange/orange_bloque2.png',
            INACTIVE: '/assets/images/contract/orange/orange_bloque.png',
        },
        MOBILE: {
            ACTIVE: '/assets/images/contract/orange/orange_mobile2.png',
            INACTIVE: '/assets/images/contract/orange/orange_mobile.png',
        },
        MOBILEPREPAID: {
            ACTIVE: '/assets/images/contract/orange/orange_mobile2.png',
            INACTIVE: '/assets/images/contract/orange/orange_mobile.png',
        },
        MOBILEPOSTPAID: {
            ACTIVE: '/assets/images/contract/orange/orange_mobile2.png',
            INACTIVE: '/assets/images/contract/orange/orange_mobile.png',
        },
        MOBILEPRO: {
            ACTIVE: '/assets/images/contract/orange/orange_business2.png',
            INACTIVE: '/assets/images/contract/orange/orange_business.png',
        },
        MOBILEOBS: {
            ACTIVE: '/assets/images/contract/orange/orange_business2.png',
            INACTIVE: '/assets/images/contract/orange/orange_business.png',
        },
        INTERNET: {
            ACTIVE: '/assets/images/contract/orange/orange_internet2.png',
            INACTIVE: '/assets/images/contract/orange/orange_internet.png',
        },
        FIXE: {
            ACTIVE: '/assets/images/contract/orange/orange_fixe2.png',
            INACTIVE: '/assets/images/contract/orange/orange_fixe.png',
        },
        OPEN: {
            ACTIVE: '/assets/images/contract/orange/orange_open2.png',
            INACTIVE: '/assets/images/contract/orange/orange_open.png',
        },
        SUGGESTED: {
            ACTIVE: '/assets/images/contract/orange/orange_bloque2.png',
            INACTIVE: '/assets/images/contract/orange/orange_bloque.png',
        },
        '3GPLUS': {
            ACTIVE: '/assets/images/contract/orange/orange_3gplus2.png',
            INACTIVE: '/assets/images/contract/orange/orange_3gplus.png',
        },
        DEFAULT: {
            ACTIVE: '/assets/images/contract/orange/orange_default2.png',
            INACTIVE: '/assets/images/contract/orange/orange_default.png',
        },
    },
    SOSH: {
        ACCUEIL: {
            ACTIVE: '/assets/images/contract/sosh/sosh_accueil2.png',
            INACTIVE: '/assets/images/contract/sosh/sosh_accueil.png',
        },
        ADD_CONTRACT: {
            ACTIVE: '/assets/images/contract/sosh/sosh_ajouter2.png',
            INACTIVE: '/assets/images/contract/sosh/sosh_ajouter.png',
        },
        BLOCKED: {
            ACTIVE: '/assets/images/contract/sosh/sosh_bloque2.png',
            INACTIVE: '/assets/images/contract/sosh/sosh_bloque.png',
        },
        FIXE: {
            ACTIVE: '/assets/images/contract/orange/orange_fixe2.png',
            INACTIVE: '/assets/images/contract/orange/orange_fixe.png',
        },
        INTERNET: {
            ACTIVE: '/assets/images/contract/sosh/sosh_internet2.png',
            INACTIVE: '/assets/images/contract/sosh/sosh_internet.png',
        },
        MOBILE: {
            ACTIVE: '/assets/images/contract/sosh/sosh_mobile2.png',
            INACTIVE: '/assets/images/contract/sosh/sosh_mobile.png',
        },
        MOBILEPREPAID: {
            ACTIVE: '/assets/images/contract/sosh/sosh_mobile2.png',
            INACTIVE: '/assets/images/contract/sosh/sosh_mobile.png',
        },
        MOBILEPOSTPAID: {
            ACTIVE: '/assets/images/contract/sosh/sosh_mobile2.png',
            INACTIVE: '/assets/images/contract/sosh/sosh_mobile.png',
        },
        MOBILEPRO: {
            ACTIVE: '/assets/images/contract/orange/orange_business2.png',
            INACTIVE: '/assets/images/contract/orange/orange_business.png',
        },
        MOBILEOBS: {
            ACTIVE: '/assets/images/contract/orange/orange_business2.png',
            INACTIVE: '/assets/images/contract/orange/orange_business.png',
        },
        OPEN: {
            ACTIVE: '/assets/images/contract/sosh/sosh_open2.png',
            INACTIVE: '/assets/images/contract/sosh/sosh_open.png',
        },
        PRO: {
            ACTIVE: '/assets/images/contract/sosh/sosh_orange2.png',
            INACTIVE: '/assets/images/contract/sosh/sosh_orange.png',
        },
        OBS: {
            ACTIVE: '/assets/images/contract/sosh/sosh_orange2.png',
            INACTIVE: '/assets/images/contract/sosh/sosh_orange.png',
        },
        SWITCH_CONTRACT: {
            ACTIVE: '/assets/images/contract/orange/orange_sosh2.png',
            INACTIVE: '/assets/images/contract/orange/orange_sosh.png',
        },
        WARNING: {
            ACTIVE: '/assets/images/contract/sosh/sosh_warning2.png',
            INACTIVE: '/assets/images/contract/sosh/sosh_warning.png',
        },
        SUGGESTED: {
            ACTIVE: '/assets/images/contract/sosh/sosh_bloque2.png',
            INACTIVE: '/assets/images/contract/sosh/sosh_bloque.png',
        },
        '3GPLUS': {
            ACTIVE: '/assets/images/contract/orange/orange_3gplus2.png',
            INACTIVE: '/assets/images/contract/orange/orange_3gplus.png',
        },
        DEFAULT: {
            ACTIVE: '/assets/images/contract/sosh/sosh_default2.png',
            INACTIVE: '/assets/images/contract/sosh/sosh_default.png',
        },
    },
};

export const FamilyPicto = {
    ALL: {
        INACTIVE: '/assets/images/family/unbranded/unbranded_avatar_all.png',
        ORANGE: '/assets/images/family/orange/orange_avatar_all.png',
        SOSH: '/assets/images/family/sosh/sosh_avatar_all.png',
    },
    '0': {
        INACTIVE: '/assets/images/family/unbranded/unbranded_avatar_0.png',
        ORANGE: '/assets/images/family/orange/orange_avatar_0.png',
        SOSH: '/assets/images/family/sosh/sosh_avatar_0.png',
    },
    '1': {
        INACTIVE: '/assets/images/family/unbranded/unbranded_avatar_1.png',
        ORANGE: '/assets/images/family/orange/orange_avatar_1.png',
        SOSH: '/assets/images/family/sosh/sosh_avatar_1.png',
    },
    '2': {
        INACTIVE: '/assets/images/family/unbranded/unbranded_avatar_2.png',
        ORANGE: '/assets/images/family/orange/orange_avatar_2.png',
        SOSH: '/assets/images/family/sosh/sosh_avatar_2.png',
    },
    '3': {
        INACTIVE: '/assets/images/family/unbranded/unbranded_avatar_3.png',
        ORANGE: '/assets/images/family/orange/orange_avatar_3.png',
        SOSH: '/assets/images/family/sosh/sosh_avatar_3.png',
    },
    '4': {
        INACTIVE: '/assets/images/family/unbranded/unbranded_avatar_4.png',
        ORANGE: '/assets/images/family/orange/orange_avatar_4.png',
        SOSH: '/assets/images/family/sosh/sosh_avatar_4.png',
    },
    '5': {
        INACTIVE: '/assets/images/family/unbranded/unbranded_avatar_5.png',
        ORANGE: '/assets/images/family/orange/orange_avatar_5.png',
        SOSH: '/assets/images/family/sosh/sosh_avatar_5.png',
    },
    '6': {
        INACTIVE: '/assets/images/family/unbranded/unbranded_avatar_6.png',
        ORANGE: '/assets/images/family/orange/orange_avatar_6.png',
        SOSH: '/assets/images/family/sosh/sosh_avatar_6.png',
    },
    '7': {
        INACTIVE: '/assets/images/family/unbranded/unbranded_avatar_7.png',
        ORANGE: '/assets/images/family/orange/orange_avatar_7.png',
        SOSH: '/assets/images/family/sosh/sosh_avatar_7.png',
    },
    '8': {
        INACTIVE: '/assets/images/family/unbranded/unbranded_avatar_8.png',
        ORANGE: '/assets/images/family/orange/orange_avatar_8.png',
        SOSH: '/assets/images/family/sosh/sosh_avatar_8.png',
    },
    '9': {
        INACTIVE: '/assets/images/family/unbranded/unbranded_avatar_9.png',
        ORANGE: '/assets/images/family/orange/orange_avatar_9.png',
        SOSH: '/assets/images/family/sosh/sosh_avatar_9.png',
    },
    '10': {
        INACTIVE: '/assets/images/family/unbranded/unbranded_avatar_10.png',
        ORANGE: '/assets/images/family/orange/orange_avatar_10.png',
        SOSH: '/assets/images/family/sosh/sosh_avatar_10.png',
    },
};

const FamilyPictoOneI = {};

let id;
for (let avatarId = 0; avatarId <= 20; avatarId++) {
    id = avatarId.toString();
    FamilyPictoOneI[id] = {
        INACTIVE: `https://proxymedia.woopic.com/api/v1/images/1211%2Favatars%2F${id}.png?format=250x250`,
        ORANGE: `https://proxymedia.woopic.com/api/v1/images/1211%2Favatars%2F${id}_selected.png?format=250x250`,
        DISABLED: `https://proxymedia.woopic.com/api/v1/images/1211%2Favatars%2F${id}_disabled.png?format=250x250`,
    };
}

FamilyPictoOneI['0']['ORANGE'] = FamilyPictoOneI['0']['INACTIVE'];
FamilyPictoOneI['0']['DISABLED'] = FamilyPictoOneI['0']['INACTIVE'];

export { FamilyPictoOneI };

export const HeaderImg = {
    ORANGE: '/assets/images/header-orange.png',
    FIRST: '/assets/images/header-first.png',
    SOSH: '/assets/images/header-sosh.png',
    PRO: '/assets/images/header-pro.png',
};

// tslint:disable:no-var-requires
// tslint:enable

// File path is either in default export or not, depending on the loader used (different between angular and storybook)
export const BrandPicto = {
    ORANGE: '/assets/images/logo-orange.svg',
    SOSH: '/assets/images/logo-sosh.svg',
};
